export interface PurchaseOrderLineValue {
  description: string;
  value: number;
  productType: string;
  unitOfMeasure: string;
  quantity: number;
  typeValue: number;
}
